export * from './project.service';
import { ProjectService } from './project.service';
export * from './project.serviceInterface';
export const APIS = [ProjectService];
